import { ajaxCall } from "@/shared/connection/ajax-call";
import {
    handleErrorByMessage,
    handleErrorNotAnOwner,
} from "@/shared/connection/with-store-error-handlers";
import { makeLogger } from "@/shared/consola";

const logger = makeLogger("footers.service");

const FOOTER_ENDPOINT = `/footers`;

export const footersService = {
    getOneByLegalUuid(uuid = "") {
        logger.trace("getOneByLegalUuid", uuid);
        return ajaxCall.get(`${FOOTER_ENDPOINT}/legal/${uuid}`).catch(handleErrorNotAnOwner());
    },
    getOneByLegalUuidForRender(uuid = "") {
        return ajaxCall
            .get(`${FOOTER_ENDPOINT}/legal/${uuid}/render`)
            .catch(handleErrorNotAnOwner());
    },
    getCompanyData(nip) {
        return ajaxCall
            .post(`${FOOTER_ENDPOINT}/company-details`, { nip })
            .catch(handleErrorByMessage());
    },
};
